import React, { Component } from "react";
import { Grid, Col, Row, Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import WebfineryNavbar from "./WebfineryNavbar";
import Footer from "./content/Footer.js";
import Hero from "./content/Hero.js";
import Helmet from 'react-helmet';
import LastCall from "./content/LastCall.js";
import UserCondition from "./UserCondition";
import Feature from "./content/Feature";
import ApiKeyDashboard from "./api/ApiKeyDashboard";
import ContactModalContainer from "./ContactModalContainer";


import './content/content.css';

class VisitRankPage extends Component {

	constructor() {
		super();
		this.state = {modalToggle: false};
		this.amazonResponse = this.amazonResponse.bind(this);
		this.handleRequestAccess = this.handleRequestAccess.bind(this);
	}

	componentDidMount() {
		window.scrollTo(0, 0);
	}

	amazonResponse() {
		return <span>{"{"} "domain" : "amazon.com", "rank": 19 {"}"}</span>;
	}

	handleRequestAccess() {
		this.setState({modalToggle: !this.state.modalToggle});
	}

    render() {
        return (
            <div>
            	<Helmet title="Visit Rank"/>
                <WebfineryNavbar/>
                <Hero>
                	<h1>Visit Rank API</h1>
                	<h2>Get a rank for any of 385 million web domains</h2>
                	<h3>{this.amazonResponse()}</h3>
					<div>
						<UserCondition isLoggedIn={false}>
							<LinkContainer to="/signup">
								<Button bsStyle="success" bsSize="lg" onClick={this.handleShowContactUs}>Sign Up for API Key</Button>
							</LinkContainer>
						</UserCondition>

						<UserCondition isLoggedIn={true}>
							<a href="https://www.visitrank.com" className="btn btn-success btn-lg" target="_blank">See it in Action</a>							
						</UserCondition>

						<a href="#docs" className="btn btn-default btn-lg">Learn more</a>
					</div>
                </Hero>
                
				<Feature shade={true}>
	      			<h3 id="docs">Docs</h3>
	  				<div className={'benefit inner-benefit'}>
						<h5><i className="fa fa-bar-chart fa-3x" aria-hidden="true"></i></h5>
	  					<h4>EXAMPLE</h4>
	  					<div>
	  						<h5>Request</h5>
	  						<code>
	  							curl "https://api.webfinery.com/ranks?domain=amazon.com&amp;key=[your key]"
	  						</code>
	  						<h5>Response</h5>
	  						<code>
	  							{this.amazonResponse()}
	  						</code>
	  						<h5>That's it!</h5>
	  					</div>
		   			</div>
		   		</Feature>

		      	<Feature innerFeatureList={true} shade={true} h3="Pricing">
		      		<Feature>
		      				<h5><i className="fa fa-star-o" aria-hidden="true"></i></h5>
		  					<h4>Basic plan (free)</h4>	  					
		  					<div>
		  						<h5>
		  							3000 requests / month<br />
		  							<small>(100 requests / day)</small>
		  						</h5>
		  					</div>
		      		</Feature>
		      		<Feature>
		      				<h5>
		      					<i className="fa fa-star" aria-hidden="true"></i>
		      					<i className="fa fa-star" aria-hidden="true"></i>
		      					<i className="fa fa-star" aria-hidden="true"></i>
		      				</h5>
		  					<h4>Production Plan</h4>
		  					<h5>
		  						Extended request limit<br />
		  						Extended service availability
		  					</h5>
		  					<Button onClick={this.handleRequestAccess}>Request Access</Button>
		      		</Feature>
				</Feature>		      		

			   <UserCondition isLoggedIn={true}>
		     		<Feature shade={true}>
		      			<h3>API Access</h3>
		  				<div className={'benefit inner-benefit'}>
							<h5><i className="fa fa-key fa-3x" aria-hidden="true"></i></h5>
		  					<h4>Your secret API keys</h4>
		  					<h5>API keys are like your passwords. Don't share them. Keep them safe.</h5>
			   				<ApiKeyDashboard/>
			   			</div>
			   		</Feature>
			   </UserCondition>


                <UserCondition isLoggedIn={false}>
	                <LastCall>
	                	<Grid>
	                		<Row>
	                			<Col md={12} className="lastCallHeader">
	                				<h3>Sign up to get a free API Key</h3>
	                			</Col>
	                		</Row>
	                		<Row>
	                			<Col md={12}>
									<LinkContainer to="/signup">                		
										<Button bsStyle="success" bsSize="lg">Create Free Account</Button>
									</LinkContainer>                			
	                			</Col>
	                		</Row>
	                	</Grid>                	
	                </LastCall>
	            </UserCondition>

				<ContactModalContainer toggle={this.state.modalToggle} topic="Visit Rank API" cue="Production Plan" push="Request Access" submittedLabel="submittedLabel"/>

                <Footer/>
            </div>
        );
    }
}

export default VisitRankPage;



// WEBPACK FOOTER //
// ./src/VisitRankPage.js